//@ts-nocheck
import React from "react";

export const ConfigurationProductPage = () => {
  return <div></div>;
};
